import { render, staticRenderFns } from "./EditorialList.vue?vue&type=template&id=20860cea&"
import script from "./EditorialList.vue?vue&type=script&lang=js&"
export * from "./EditorialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports